import { createStore } from 'vuex'
import state from './user'
import getters from './getters'

export default createStore({
  state,
  getters
})
